import { render, staticRenderFns } from "./DomeAlertModal.vue?vue&type=template&id=3979773a&"
import script from "./DomeAlertModal.vue?vue&type=script&lang=ts&"
export * from "./DomeAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports